import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [showWhyChooseDetails, setShowWhyChooseDetails] = useState(false);
  const [onboardingStep, setOnboardingStep] = useState(0); // 0 = language selection, 1 = name input
  const [selectedLanguage, setSelectedLanguage] = useState(null); // 'persian' or 'english'

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    setOnboardingStep(1);
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (userName.trim()) {
      const hubPath = selectedLanguage === 'english' ? '/dashboard/learning-hub-english' : '/dashboard/learning-hub-farsi';
      navigate(hubPath);
    }
  };

  return (
    <div style={{
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      color: '#333',
      overflow: 'hidden'
    }}>
      {/* Hero Section */}
      <section className="hero">
        <div className="heroShell">
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: 'clamp(18px, 3vw, 34px)'
          }}>
            <h1 className="heroWelcome" style={{ margin: 0 }}>Welcome to Paria.ai</h1>
            <button
              onClick={() => navigate('/dashboard/learning-hub-farsi')}
              style={{
                border: '2px solid rgba(255, 255, 255, 0.8)',
                borderRadius: '16px',
                padding: '20px 40px',
                fontFamily: "'Fredoka', sans-serif",
                fontWeight: '700',
                fontSize: 'clamp(24px, 3vw, 36px)',
                color: '#ffffff',
                background: 'rgba(255, 255, 255, 0.4)',
                backdropFilter: 'blur(10px)',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.6)';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.4)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
              }}
            >
              Parental Mode
            </button>
          </div>

          <div className="heroCard">
            {onboardingStep === 0 ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '30px',
                padding: '40px 20px'
              }}>
                <h2 className="heroHeadline" style={{ textAlign: 'center', marginBottom: '20px' }}>
                  Pick Your Language, Little Star!
                </h2>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '40px',
                  width: '100%',
                  maxWidth: '900px',
                  justifyContent: 'center',
                  flexWrap: 'wrap'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '0 0 auto'
                  }}>
                    <img
                      src="/Cute-star.gif"
                      alt="Little Star"
                      style={{
                        width: 'clamp(200px, 25vw, 350px)',
                        height: 'auto',
                        objectFit: 'contain',
                        transition: 'transform 0.6s ease',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'rotate(360deg)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'rotate(0deg)';
                      }}
                      draggable={false}
                    />
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '25px',
                    flex: '1 1 auto',
                    minWidth: '300px',
                    maxWidth: '500px',
                    position: 'relative',
                    zIndex: 2
                  }}>
                    <button
                      onClick={() => handleLanguageSelect('persian')}
                      style={{
                        width: '100%',
                        padding: '30px 40px',
                        borderRadius: '20px',
                        border: 'none',
                        fontFamily: "'Fredoka', sans-serif",
                        fontWeight: '700',
                        fontSize: 'clamp(28px, 3vw, 40px)',
                        color: '#ffffff',
                        background: 'linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%)',
                        boxShadow: '0 8px 25px rgba(155, 89, 182, 0.4)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        textAlign: 'center'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-3px)';
                        e.target.style.boxShadow = '0 12px 30px rgba(155, 89, 182, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 8px 25px rgba(155, 89, 182, 0.4)';
                      }}
                    >
                      I want to learn Persian.
                    </button>
                    <button
                      onClick={() => handleLanguageSelect('english')}
                      style={{
                        width: '100%',
                        padding: '30px 40px',
                        borderRadius: '20px',
                        border: 'none',
                        fontFamily: "'Fredoka', sans-serif",
                        fontWeight: '700',
                        fontSize: 'clamp(28px, 3vw, 40px)',
                        color: '#ffffff',
                        background: 'linear-gradient(135deg, #3498DB 0%, #2980B9 100%)',
                        boxShadow: '0 8px 25px rgba(52, 152, 219, 0.4)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        textAlign: 'center'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-3px)';
                        e.target.style.boxShadow = '0 12px 30px rgba(52, 152, 219, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 8px 25px rgba(52, 152, 219, 0.4)';
                      }}
                    >
                      I want to learn English.
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="heroGrid">
                <div className="heroCopy">
                  <h2 className="heroHeadline">
                    Write your<br />name here
                  </h2>
                  <p className="heroSub">If you wanna learn join and enjoy.</p>

                  <form onSubmit={handleNameSubmit} className="heroForm">
                    <input
                      type="text"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                      placeholder="Enter your name"
                      className="heroInput"
                      autoComplete="name"
                    />

                    <button
                      type="submit"
                      disabled={!userName.trim()}
                      className="heroButton"
                    >
                      Start
                    </button>
                  </form>
                </div>

                <div className="heroArt" aria-hidden="true">
                  <img
                    src="/paria-4.png"
                    alt=""
                    className="heroImage"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Features Section - Different Color */}
      <section style={{
        minHeight: showWhyChooseDetails ? 'auto' : 'auto',
        width: '100%',
        backgroundColor: '#F4ABBA', // Pink background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '50px 20px'
      }}>
        <div style={{
          maxWidth: '1200px',
          width: '100%',
          textAlign: 'center'
        }}>
          <button
            onClick={() => setShowWhyChooseDetails(!showWhyChooseDetails)}
            style={{
              backgroundColor: 'white',
              border: '2px solid #DD2E44',
              borderRadius: '15px',
              padding: '12px 24px',
              fontSize: '24px',
              fontWeight: '700',
              color: '#DD2E44',
              cursor: 'pointer',
              marginBottom: showWhyChooseDetails ? '30px' : '40px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(221, 46, 68, 0.2)',
              fontFamily: "'Nunito', sans-serif"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.3)';
              e.target.style.backgroundColor = '#fff5f7';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(221, 46, 68, 0.2)';
              e.target.style.backgroundColor = 'white';
            }}
          >
            Why Choose Paria.ai? {showWhyChooseDetails ? '▼' : '▶'}
          </button>

          {showWhyChooseDetails && (
            <div style={{
              backgroundColor: 'white',
              borderRadius: '20px',
              padding: '35px',
              textAlign: 'left',
              boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
              maxWidth: '900px',
              margin: '0 auto'
            }}>
              <div style={{ marginBottom: '35px' }}>
                <h3 style={{
                  fontSize: '28px',
                  fontWeight: '800',
                  color: '#DD2E44',
                  marginBottom: '15px',
                  fontFamily: "'Fredoka', sans-serif"
                }}>
                  Play-based & story-driven learning
                </h3>
                <p style={{
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '1.8',
                  fontFamily: "'Nunito', sans-serif"
                }}>
                  Language is learned through games, storytelling, movement, visuals, and interaction, not memorization or pressure.
                </p>
              </div>

              <div style={{ marginBottom: '35px' }}>
                <h3 style={{
                  fontSize: '28px',
                  fontWeight: '800',
                  color: '#DD2E44',
                  marginBottom: '15px',
                  fontFamily: "'Fredoka', sans-serif"
                }}>
                  Designed by a teacher, not developers alone
                </h3>
                <p style={{
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '1.8',
                  fontFamily: "'Nunito', sans-serif"
                }}>
                  Every activity reflects classroom-tested methods like TPR, role-play, vocabulary games, storytelling, and speaking tasks I have personally used with hundreds of students.
                </p>
              </div>

              <div style={{ marginBottom: '35px' }}>
                <h3 style={{
                  fontSize: '28px',
                  fontWeight: '800',
                  color: '#DD2E44',
                  marginBottom: '15px',
                  fontFamily: "'Fredoka', sans-serif"
                }}>
                  Focus on confidence, not perfection
                </h3>
                <p style={{
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '1.8',
                  fontFamily: "'Nunito', sans-serif"
                }}>
                  Children are encouraged to use English naturally, without fear of mistakes. Speaking comes before grammar rules.
                </p>
              </div>

              <div style={{ marginBottom: '35px' }}>
                <h3 style={{
                  fontSize: '28px',
                  fontWeight: '800',
                  color: '#DD2E44',
                  marginBottom: '15px',
                  fontFamily: "'Fredoka', sans-serif"
                }}>
                  Creative, artistic, and child-friendly
                </h3>
                <p style={{
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '1.8',
                  fontFamily: "'Nunito', sans-serif"
                }}>
                  With my background in fine arts and game design, Paria.ai blends education with visual storytelling, characters, and playful environments kids love.
                </p>
              </div>

              <div>
                <h3 style={{
                  fontSize: '28px',
                  fontWeight: '800',
                  color: '#DD2E44',
                  marginBottom: '15px',
                  fontFamily: "'Fredoka', sans-serif"
                }}>
                  Built for real parents and real kids
                </h3>
                <p style={{
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '1.8',
                  fontFamily: "'Nunito', sans-serif"
                }}>
                  This platform understands parents' concerns and children's needs, progress without pressure, structure without boredom.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section - Another Color */}
      <section style={{
        minHeight: 'auto',
        width: '100%',
        backgroundColor: '#A8E6CF', // Green/teal background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '50px 20px'
      }}>
        <div style={{
          maxWidth: '800px',
          width: '100%',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '48px',
            fontWeight: '800',
            color: '#DD2E44',
            marginBottom: '30px'
          }}>
            Ready to Start Learning?
          </h2>
          <p style={{
            fontSize: '24px',
            color: '#555',
            marginBottom: '40px',
            lineHeight: '1.6'
          }}>
            Play-based language learning: English for Farsi speakers, Farsi for English speakers
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => navigate('/dashboard/learning-hub-farsi')}
              style={{
                backgroundColor: 'white',
                color: '#DD2E44',
                padding: '25px 50px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '22px',
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 6px 20px rgba(221, 46, 68, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.3)';
              }}
            >
              Access Dashboard 🔒
            </button>
            <button
              onClick={() => navigate('/about')}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: '25px 50px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '22px',
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 6px 20px rgba(221, 46, 68, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.3)';
              }}
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        backgroundColor: '#2C3E50',
        color: 'white',
        padding: '40px 20px',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'center'
        }}>
          {/* Contact Information */}
          <div style={{
            marginBottom: '10px'
          }}>
            <p style={{
              fontSize: '18px',
              fontWeight: '600',
              margin: '0 0 8px 0',
              color: '#ffffff'
            }}>
              Contact information:
            </p>
            <p style={{
              fontSize: '16px',
              margin: 0,
              color: '#e0e0e0'
            }}>
              Email: <a
                href="mailto:hello@paria.ai"
                style={{
                  color: '#ffffff',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
                onMouseEnter={(e) => {
                  e.target.style.textDecoration = 'underline';
                }}
                onMouseLeave={(e) => {
                  e.target.style.textDecoration = 'none';
                }}
              >
                hello@paria.ai
              </a>
            </p>
          </div>
          
          {/* Credit */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            fontSize: '16px',
            paddingTop: '20px',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            width: '100%'
          }}>
            <span>With</span>
            <span style={{ color: '#DD2E44' }}>♥</span>
            <span>by</span>
            <a
              href="https://pariaakhavass.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#DD2E44',
                textDecoration: 'none',
                fontWeight: '600'
              }}
            >
              Paria
            </a>
          </div>
        </div>
      </footer>
      
      <style>{`
        .hero {
          min-height: auto;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding-top: clamp(32px, 4vw, 48px);
          padding-bottom: clamp(40px, 5vw, 60px);
          padding-left: 20px;
          padding-right: 20px;
          background: #F4ABBA;
        }

        .heroShell {
          width: 100%;
          max-width: 1200px;
          display: grid;
          gap: clamp(20px, 2.5vw, 32px);
          align-items: start;
        }

        .heroWelcome {
          margin: 0;
          text-align: left;
          font-family: 'Fredoka', sans-serif;
          font-weight: 700;
          font-size: clamp(40px, 5vw, 72px);
          line-height: 1.05;
          color: #ffffff;
          text-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
        }

        .heroCard {
          background: rgba(255, 255, 255, 0.96);
          border: 1px solid rgba(255, 255, 255, 0.7);
          border-radius: 28px;
          box-shadow: 0 24px 60px rgba(0, 0, 0, 0.16);
          padding: clamp(22px, 3.5vw, 48px);
          overflow: hidden;
          backdrop-filter: blur(10px);
        }

        .heroGrid {
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: clamp(24px, 4vw, 48px);
          align-items: start;
          position: relative;
        }

        .heroCopy {
          display: grid;
          gap: clamp(8px, 1.5vw, 14px);
          align-content: start;
          width: 100%;
          position: relative;
          z-index: 2;
        }

        .heroHeadline {
          margin: 0;
          font-family: 'Fredoka', sans-serif;
          font-weight: 700;
          font-size: clamp(42px, 4.5vw, 68px);
          line-height: 1.1;
          letter-spacing: -0.01em;
          color: #911ded;
        }

        .heroSub {
          margin: 0;
          font-family: 'Fredoka', sans-serif;
          font-weight: 600;
          font-size: clamp(20px, 2.2vw, 34px);
          line-height: 1.25;
          color: #666;
        }

        .heroForm {
          margin-top: clamp(6px, 1.8vw, 18px);
          display: flex;
          flex-direction: column;
          gap: 20px;
          align-items: stretch;
        }

        .heroInput {
          width: 100%;
          padding: 18px 20px;
          border-radius: 18px;
          border: 3px solid #ffa4f9;
          background: #ffffff;
          font-family: 'Fredoka', sans-serif;
          font-weight: 600;
          font-size: 28px;
          line-height: 1.1;
          color: #ff751f;
          outline: none;
          box-sizing: border-box;
          transition: box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease;
        }

        .heroInput:focus {
          border-color: rgba(145, 29, 237, 0.55);
          box-shadow: 0 0 0 6px rgba(145, 29, 237, 0.14);
          transform: translateY(-1px);
        }

        .heroInput::placeholder {
          font-size: 28px;
          font-weight: 600;
          font-family: 'Fredoka', sans-serif;
          color: #ff751f;
          opacity: 0.75;
        }

        .heroButton {
          border: none;
          border-radius: 999px;
          padding: 14px 26px;
          width: 100%;
          font-family: 'Fredoka', sans-serif;
          font-weight: 700;
          font-size: clamp(34px, 3.6vw, 48px);
          line-height: 1;
          color: #ffffff;
          letter-spacing: 0.02em;
          cursor: pointer;
          background: linear-gradient(135deg, #5AFF5C 0%, #37eb39 55%, #1FA521 100%);
          box-shadow: 0 14px 26px rgba(55, 235, 57, 0.35), 0 4px 10px rgba(0, 0, 0, 0.14);
          transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
        }

        .heroButton:hover:not(:disabled) {
          transform: translateY(1px);
          box-shadow: 0 10px 20px rgba(55, 235, 57, 0.3), 0 3px 8px rgba(0, 0, 0, 0.12);
          filter: saturate(1.05);
        }

        .heroButton:active:not(:disabled) {
          transform: translateY(3px);
          box-shadow: 0 6px 14px rgba(55, 235, 57, 0.22), 0 2px 6px rgba(0, 0, 0, 0.12);
        }

        .heroButton:disabled {
          cursor: not-allowed;
          filter: grayscale(1);
          opacity: 0.65;
          box-shadow: none;
        }

        .heroArt {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          min-height: 480px;
          position: relative;
          z-index: 1;
          margin-left: -24px;
        }

        .heroImage {
          width: min(720px, 55vw);
          height: auto;
          object-fit: contain;
          filter: drop-shadow(0 24px 48px rgba(0, 0, 0, 0.12));
          transform: translateY(-8px);
        }

        @media (max-width: 900px) {
          .heroShell > div:first-child {
            flex-direction: column;
            gap: 16px;
            align-items: center;
          }

          .heroWelcome {
            text-align: center;
            padding-left: 0;
          }

          .heroGrid {
            grid-template-columns: 1fr;
            gap: clamp(20px, 4vw, 32px);
          }

          .heroArt {
            min-height: 320px;
            align-items: center;
            order: -1;
          }

          .heroImage {
            width: min(680px, 90vw);
            transform: translateY(0);
          }

          .heroForm {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;